export default class LeadsPushDataFormat {
  constructor(code, desc) {
    this.code = code;
    this.desc = desc;
  }

  getCode() {
    return this.code;
  }

  getDesc1() {
    return this.desc;
  }
}

LeadsPushDataFormat.DEFAULT = new LeadsPushDataFormat('Default', '默认（JSON）');
LeadsPushDataFormat.TEMPLATE = new LeadsPushDataFormat('Template', '模板');

Object.freeze(LeadsPushDataFormat);
